// /* eslint-disable prefer-const */
// /* eslint-disable react-refresh/only-export-components */
// import { useFormik } from 'formik';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import Select from 'react-select';
// import { Card, CardFooter } from '@components/card/card';
// import { CardBody, Form, InputGroup } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useAppDispatch } from '@store/hooks';
// import { useNavigate } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import { TreeSelect } from 'antd';
// import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import { addApPayments, getApPaymentsList } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
// import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
// import useGetPaymentTypeList from '@hooks/Finance/ApPayments/useGetPaymentTypeList';
// import { AddApPaymentsSchema } from '../../../../ValidationForm/validationSchema';
// import { useState } from 'react';
// import NeatixModal from '@components/Modal/NeatixModal';
// import ChooseType from './ChooseType';
// import ApScheduleList from '../ApScheduleList';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import { paymentTypeEnum } from '../paymentTypeEnum';
// import PaymentDetailsCard from './PaymentDetailsCard';
// import { useDailyRate } from '@hooks/Finance/DailyRates/useDailyRate';

// const Add = () => {
//   const [showModal, setShowModal] = useState(true);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const { Currency, loading, error } = useLookupCurrency();

//   const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();
//   const { treeSuppliersData, error: error2, loading: loading2 } = useGetSuppliersList();
//   const { PaymentMethodList, error: error3, loading: loading3 } = useGetPaymentMethod();
//   const { groupedOptions, error: error4, loading: loading4 } = useGetBankAccountsList();
//   const { PaymentTypeList  } = useGetPaymentTypeList();

//   //#region Formik
//   const formik = useFormik({
//     initialValues: {
//       // prePaymentTotal: 0, // ليس في البوست
//       //
//       paymentType: paymentTypeEnum.Standard, // قياسي
//       paymentDate: new Date().toISOString().split('T')[0],
//       apBankAccountId: '',
//       paymentMethodId: '',
//       amount: 0,
//       currencyCode: 'SAR',
//       currencyConversionRate: 1,
//       peopleId: null,
//       organizationId: '',
//       creditMemoInvoiceId: '',
//       prePaymentId: '',
//       description: '',

//       scheduleList: [
//         {
//           apPaymentScheduleId: '',
//           amount: 0
//         }
//       ]
//     },

//     enableReinitialize: true,
//     validationSchema: AddApPaymentsSchema(t),

//     onSubmit: async values => {
//       let isConfirmation = await confirmAction('هل أنت متأكد من أنك تريد إضافة هذا السداد؟');
//       if (!isConfirmation) {
//         formik.setSubmitting(false);
//         return;
//       }

//       let totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0);

//       dispatch(
//         addApPayments({
//           apBankAccountId: values.apBankAccountId || null,
//           paymentMethodId: values.paymentMethodId || null,
//           paymentDate: values.paymentDate,
//           amount: [paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)
//             ? values.amount
//             : totalAmount,
//           currencyCode: values.currencyCode,
//           currencyConversionRate: rate,
//           peopleId: values.peopleId,
//           organizationId: values.organizationId,
//           paymentType: values.paymentType,
//           creditMemoInvoiceId: values.creditMemoInvoiceId || null,
//           prePaymentId: values.prePaymentId || null,
//           description: values.description?.trim() || '',

//           scheduleList: [paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)
//             ? []
//             : values.scheduleList.map((item: any) => ({
//                 apPaymentScheduleId: item.apPaymentScheduleId,
//                 amount: item.amount
//               }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             dispatch(getApPaymentsList());
//             navigate('/AP/ApPayments', { replace: true });
//           } else {
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           CustomAlert({ action: 'Error' });
//         })
//         .finally(() => {
//           formik.setSubmitting(false);
//         });
//     }
//   });
//   const { values, handleChange: formikhandleChange, errors, touched, setFieldValue, setFieldTouched } = formik;
//   //#endregion

//   const {
//     rate,
//     loading: loadingRate,
//     error: errorRate,
//     refetch
//   } = useDailyRate({
//     currencyCode: values.currencyCode,
//     date: values.paymentDate
//   });

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: ':moduleHome'
//           },
//           {
//             name: 'PaymentVouchers',
//             link: '/AP/ApPayments'
//           },
//           {
//             name: 'AddNewPaymentVoucher',
//             link: null
//           }
//         ]}
//         PageName='AddNewPaymentVoucher'
//       />

//       <Card>
//         <Loading
//           loading={loading || loading1 || loading2 || loading3 || loading4 }
//           error={error || error1 || error2 || error3 || error4 }
//         >
//           <Form onSubmit={formik.handleSubmit}>
//             <CardBody>
//               <div className='row'>
//                 {/* نوع الدفع */}
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('PaymentType')}</label>
//                     <Form.Select
//                       disabled
//                       className='form-select'
//                       name='paymentType'
//                       onChange={formikhandleChange}
//                       value={values.paymentType || ''}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {PaymentTypeList?.map((item, idx) => (
//                         <option key={idx} value={item.id}>
//                           {i18n.language === 'en' ? item.name : item.name2}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     <div className='text-danger small'>{touched.paymentType && formik.errors.paymentType}</div>
//                   </div>
//                 </div>
//                 {/* {t('المورد')} */}
//                 <div className='col-lg-3 '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Supplier')}</label>
//                     <TreeSelect
//                       disabled
//                       showSearch
//                       className='w-100'
//                       treeLine
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                       allowClear
//                       treeDefaultExpandAll={false} // لا تقم بتوسيع كل العقد افتراضيًا
//                       // loadData={} // يتم تحميل البيانات عند الطلب
//                       // onSearch={} // تنفيذ البحث عند كتابة المستخدم
//                       value={values.peopleId}
//                       onChange={option => {
//                         formik.setFieldValue('peopleId', option === null ? null : option);
//                       }}
//                       treeData={treeSuppliersData}
//                       treeNodeFilterProp='title'
//                     />
//                     <div className='text-danger small'>{touched.peopleId && errors.peopleId}</div>
//                   </div>
//                 </div>
//                 {/* ('الفرع') */}
//                 <div className='col-lg-3  '>
//                   <div className='form-group mb-3'>
//                     {/* <label className="form-label">{t('Branch')}</label> */}
//                     <label className='form-label'>{t('الوحدة التشغيليـة')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading3}
//                       isSearchable={true}
//                       isClearable
//                       options={OperatingUnitOptions}
//                       value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.organizationId)}
//                       onChange={(option: any) => setFieldValue('organizationId', option === null ? null : option.value)}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />
//                     <div className='text-danger small'>{touched.organizationId && errors.organizationId}</div>
//                   </div>
//                 </div>
//                 {/* التاريخ */}
//                 <div className='col-lg-3  '>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Date')}</label>
//                     <Form.Control
//                       className='form-control'
//                       type='date'
//                       name='paymentDate'
//                       onChange={formikhandleChange}
//                       value={values.paymentDate || ''}
//                       // isInvalid={!!(touched.paymentDate && errors.paymentDate)}
//                     />
//                     <div className='text-danger small'>{touched.paymentDate && errors.paymentDate}</div>
//                   </div>
//                 </div>
//                 {![paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.ApplyPrePayment].includes(values.paymentType) && (
//                   <>
//                     {/* طريقة الدفع */}
//                     <div className='col-lg-3 '>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('PaymentMethod')}</label>
//                         <Form.Select
//                           className='form-select'
//                           name='paymentMethodId'
//                           onChange={formik.handleChange}
//                           value={formik.values.paymentMethodId || ''}
//                           // isInvalid={
//                           //   !!(formik.touched.paymentMethodId && formik.errors.paymentMethodId)
//                           // }
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                           {PaymentMethodList?.map((item: any, idx: number) => (
//                             <option key={++idx} value={item.id}>
//                               {i18n.language === 'en' ? item.name : item.name2}
//                             </option>
//                           ))}
//                         </Form.Select>
//                         <div className='text-danger small'>{touched.paymentMethodId && errors.paymentMethodId}</div>
//                       </div>
//                     </div>
//                     {/* apBankAccountId */}
//                     <div className='col-lg-3 '>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Bank / Fund')}</label>

//                         <Select
//                           classNamePrefix='react-select'
//                           // isLoading={loading5}
//                           isSearchable={true}
//                           isClearable
//                           options={groupedOptions}
//                           value={groupedOptions?.find((f: any) => f?.value === formik.values.apBankAccountId)}
//                           onChange={(option: any) =>
//                             setFieldValue('apBankAccountId', option === null ? null : option?.value)
//                           }
//                           placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                         />
//                         <div className='text-danger small'>{touched.apBankAccountId && errors.apBankAccountId}</div>
//                       </div>
//                     </div>
//                     {/* ('Currency') */}
//                     <div className='col-lg-3'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'> {t('Currency')} </label>
//                         <Form.Select
//                           className='form-select'
//                           name='currencyCode'
//                           onChange={formikhandleChange}
//                           value={values.currencyCode || ''}
//                           // isInvalid={!!(touched.currencyCode && errors.currencyCode)}
//                         >
//                           <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                           {Currency &&
//                             Currency?.map((item: any, idx: number) => (
//                               <option key={++idx} value={item.currencyCode}>
//                                 {item.description}
//                               </option>
//                             ))}
//                         </Form.Select>
//                         <div className='text-danger small'>{touched.currencyCode && errors.currencyCode}</div>
//                       </div>
//                     </div>
//                     {/* ('معدل العملة') */}
//                     <div className='col-lg-3 '>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'> {t('CurrencyConversionRate')} </label>
//                         <InputGroup>
//                           <Form.Control
//                             className='form-control text-center'
//                             type='text'
//                             readOnly
//                             value={loadingRate ? '' : errorRate ? 'فشل التحميل' : rate}
//                             placeholder={loadingRate ? 'جاري التحميل...' : ''}
//                           />

//                           {loadingRate && (
//                             <InputGroup.Text>
//                               <div className='spinner-border spinner-border-sm text-primary'></div>
//                             </InputGroup.Text>
//                           )}

//                           {errorRate && !loadingRate && (
//                             <InputGroup.Text style={{ padding: '0' }}>
//                               <button
//                                 type='button'
//                                 className='btn btn-outline-warning h-100 px-2'
//                                 onClick={refetch}
//                                 title='إعادة تحميل سعر الصرف'
//                               >
//                                 <i className='fas fa-redo'></i>
//                               </button>
//                             </InputGroup.Text>
//                           )}
//                         </InputGroup>

//                         {errorRate && !loadingRate && (
//                           <small className='text-warning mt-1 d-block text-center'>
//                             <i className='fas fa-exclamation-circle me-1'></i>
//                             تعذر تحميل السعر
//                             <button
//                               type='button'
//                               className='btn btn-link btn-sm p-0 text-warning ms-1'
//                               onClick={refetch}
//                             >
//                               (إعادة المحاولة)
//                             </button>
//                           </small>
//                         )}
//                       </div>
//                     </div>

//                     {/* الوصف */}
//                     <div className='col-lg-12'>
//                       <div className='form-group mb-3'>
//                         <label className='form-label'>{t('Description')}</label>
//                         <Form.Control
//                           as='textarea'
//                           rows={1}
//                           className='form-control'
//                           name='description'
//                           autoComplete='off'
//                           value={values.description || ''}
//                           onChange={formikhandleChange}
//                           onBlur={() => setFieldTouched('description', true)}
//                           placeholder={i18n.language === 'ar' ? 'اكتب الوصف...' : 'Write description...'}
//                         />
//                         <div className='text-danger small'>{touched.description && (errors as any).description}</div>
//                       </div>
//                     </div>
//                   </>
//                 )}
//                 {values.paymentType === paymentTypeEnum.PrePayment && (
//                   <div className='col-lg-3'>
//                     <div className='form-group mb-3'>
//                       <label className='form-label'>{t('PrePaymentAmount')}</label>
//                       <Form.Control
//                         className='form-control text-center fs-5 fw-bold text-theme'
//                         type='text'
//                         autoComplete='off'
//                         name='amount'
//                         onChange={formikhandleChange}
//                         value={values.amount || ''}
//                         onInput={e => {
//                           const input = e.target as HTMLInputElement;
//                           input.value = input.value.replace(/[^0-9]/g, '');
//                         }}
//                       />
//                       <div className='text-danger small'>{errors.amount}</div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </CardBody>

//             <CardFooter className='mt-0 p-0'>
//               <PaymentDetailsCard
//                 paymentType={values.paymentType}
//                 Id={
//                   // values.paymentType === paymentTypeEnum.ApplyDebitMemo
//                   [paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(values.paymentType)
//                     ? values.creditMemoInvoiceId
//                     : values.paymentType === paymentTypeEnum.ApplyPrePayment
//                     ? values.prePaymentId
//                     : null
//                 }
//                 scheduleCount={formik.values.scheduleList?.length || 0}
//               />

//               <hr className='my-4' />

//               {/* <div hidden={values.paymentType === paymentTypeEnum.PrePayment}> */}
//               <div hidden={[paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)}>
//                 <ApScheduleList formik={formik} />
//               </div>

//               <div className=' text-center my-3'>
//                 <button
//                   disabled={formik.isSubmitting}
//                   type='submit'
//                   className='btn btn-lg me-1 btn-theme mb-1 rounded-2'
//                 >
//                   {formik.isSubmitting ? (
//                     <div className='spinner-border spinner-border-sm me-2'></div>
//                   ) : (
//                     <i className='fas fa-lg fa-fw me-2 fa-credit-card'></i>
//                   )}
//                   {t('Pay')}
//                 </button>
//                 <button
//                   type='button'
//                   className='btn btn-lg me-1 btn-default mb-1 rounded-2'
//                   onClick={() => navigate('/AP/ApPayments', { replace: true })}
//                 >
//                   <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//                 </button>
//               </div>
//             </CardFooter>
//           </Form>
//         </Loading>
//       </Card>

//       <NeatixModal
//         show={showModal}
//         setShow={setShowModal}
//         size='xl'
//         bodyClassName='p-0'
//         showHeader={false}
//         keyboard={false}
//         backdrop={true}
//         centered
//       >
//         <Card>
//           <ChooseType formik={formik} onClose={() => setShowModal(false)} />
//         </Card>
//       </NeatixModal>
//     </>
//   );
// };

// export default Add;

/* eslint-disable prefer-const */
/* eslint-disable react-refresh/only-export-components */
// import { useFormik } from 'formik';
// import { useState, useEffect, useMemo } from 'react';
// import { useTranslation } from 'react-i18next';
// import Select from 'react-select';
// import { TreeSelect } from 'antd';
// import { Card } from '@components/card/card';
// import { CardBody, Form, InputGroup, Badge, Row, Col } from 'react-bootstrap';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import Loading from '@components/Shared/Loader/Loading';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
// import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
// import useGetPaymentTypeList from '@hooks/Finance/ApPayments/useGetPaymentTypeList';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import { useAppDispatch } from '@store/hooks';
// import { useNavigate } from 'react-router-dom';
// import { addApPayments, getApPaymentsList } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
// import { AddApPaymentsSchema } from '../../../../ValidationForm/validationSchema';
// import NeatixModal from '@components/Modal/NeatixModal';
// import ChooseType from './ChooseType';
// import ApScheduleList from '../ApScheduleList';
// import { paymentTypeEnum } from '../paymentTypeEnum';
// import PaymentDetailsCard from './PaymentDetailsCard';
// import { useDailyRate } from '@hooks/Finance/DailyRates/useDailyRate';

// const Add = () => {
//   const [showModal, setShowModal] = useState(true);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   // الحالة
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // البيانات المرجعية
//   const { Currency, loading: loadingCurrency } = useLookupCurrency();
//   const { OperatingUnitOptions, loading: loadingOperatingUnits } = useGetOperatingUnitWithPermission();
//   const { treeSuppliersData, loading: loadingSuppliers } = useGetSuppliersList();
//   const { PaymentMethodList, loading: loadingPaymentMethods } = useGetPaymentMethod();
//   // const { groupedOptions, loading: loadingBankAccounts } = useGetBankAccountsList();
//   const { PaymentTypeList } = useGetPaymentTypeList();

//   const todayDate = useMemo(() => new Date().toISOString().split('T')[0], []);

//   // Formik
//   const formik = useFormik({
//     initialValues: {
//       paymentType: paymentTypeEnum.Standard,
//       paymentDate: todayDate,
//       apBankAccountId: '',
//       paymentMethodId: '',
//       amount: 0,
//       currencyCode: 'SAR',
//       currencyConversionRate: 1,
//       peopleId: null,
//       organizationId: '',
//       creditMemoInvoiceId: '',
//       prePaymentId: '',
//       description: '',
//       scheduleList: [
//         {
//           apPaymentScheduleId: '',
//           amount: 0
//         }
//       ]
//     },

//     enableReinitialize: true,
//     validationSchema: AddApPaymentsSchema(t),

//     onSubmit: async values => {
//       const isConfirmation = await confirmAction(t('هل أنت متأكد من أنك تريد إضافة هذا السداد؟'));
//       if (!isConfirmation) {
//         formik.setSubmitting(false);
//         return;
//       }

//       setIsSubmitting(true);
//       const totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0) || 0;

//       const payload = {
//         apBankAccountId: values.apBankAccountId || null,
//         paymentMethodId: values.paymentMethodId || null,
//         paymentDate: values.paymentDate,
//         amount: [paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)
//           ? values.amount
//           : totalAmount,
//         currencyCode: values.currencyCode,
//         currencyConversionRate: rate,
//         peopleId: values.peopleId,
//         organizationId: values.organizationId,
//         paymentType: values.paymentType,
//         creditMemoInvoiceId: values.creditMemoInvoiceId || null,
//         prePaymentId: values.prePaymentId || null,
//         description: values.description?.trim() || '',
//         scheduleList: [paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)
//           ? []
//           : values.scheduleList.map((item: any) => ({
//               apPaymentScheduleId: item.apPaymentScheduleId,
//               amount: item.amount
//             }))
//       };

//       try {
//         const res = await dispatch(addApPayments(payload)).unwrap();
//         if (res?.succeeded) {
//           CustomAlert({ action: 'Add' });
//           dispatch(getApPaymentsList());
//           navigate('/AP/ApPayments', { replace: true });
//         } else {
//           CustomAlert({ action: 'Error', msg: res?.message });
//         }
//       } catch (error) {
//         CustomAlert({ action: 'Error' });
//       } finally {
//         setIsSubmitting(false);
//         formik.setSubmitting(false);
//       }
//     }
//   });

//   const { values, handleChange, errors, touched, setFieldValue, setFieldTouched } = formik;

//   // const { groupedOptions, loading: loadingBankAccounts } = useGetBankAccountsList(values.organizationId);
//   const { groupedOptions } = useGetBankAccountsList(values.organizationId);

//   // تحميل جميع البيانات
//   const loadingAllData =
//     // loadingCurrency || loadingOperatingUnits || loadingSuppliers || loadingPaymentMethods || loadingBankAccounts;
//     loadingCurrency || loadingOperatingUnits || loadingSuppliers || loadingPaymentMethods ;

//   // Daily Rate
//   const {
//     rate,
//     loading: loadingRate,
//     error: errorRate,
//     refetch
//   } = useDailyRate({
//     currencyCode: values.currencyCode,
//     date: values.paymentDate
//   });

//   // دالة مساعدة لعرض رسائل الخطأ
//   const renderError = (fieldName: string) => {
//     const t = (touched as any)[fieldName];
//     const e = (errors as any)[fieldName];
//     return t && e ? <div className='text-danger small mt-1'>{e as string}</div> : null;
//   };

//   // إخفاء بعض الحقول بناءً على نوع الدفع
//   const showPaymentFields = ![
//     paymentTypeEnum.ApplyDebitMemo,
//     paymentTypeEnum.ApplyDebitMemo,
//     paymentTypeEnum.ApplyPrePayment
//   ].includes(values.paymentType);
//   const showScheduleList = ![paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType);

//   if (loadingAllData) return <Loading loading={true} />;

//   return (
//     <div className='pb-5'>
//       {/* الرأس (Header) */}
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             { name: 'Home', link: ':moduleHome' },
//             { name: t('سندات الدفع'), link: '/AP/ApPayments' },
//             { name: t('سند دفع جديد'), link: null }
//           ]}
//           PageName={
//             <div className='d-flex align-items-center'>
//               {t('سند دفع جديد')}
//               {values.paymentType && (
//                 <Badge bg='primary' className='ms-3 fs-12px'>
//                   {PaymentTypeList?.find(p => p.id === values.paymentType)?.[i18n.language === 'en' ? 'name' : 'name2']}
//                 </Badge>
//               )}
//             </div>
//           }
//         />
//       </div>

//       {/* نموذج اختيار النوع (Modal) */}
//       <NeatixModal
//         show={showModal}
//         setShow={setShowModal}
//         size='xl'
//         bodyClassName='p-0'
//         showHeader={false}
//         keyboard={false}
//         backdrop={true}
//         centered
//       >
//         <Card>
//           <ChooseType formik={formik} onClose={() => setShowModal(false)} />
//         </Card>
//       </NeatixModal>

//       {/* النموذج الرئيسي */}
//       <Form onSubmit={formik.handleSubmit}>
//         <Card className='shadow-sm border-0 mb-4'>
//           <CardBody>
//             <Row>
//               {/* نوع الدفع */}
//               <Col lg={3} md={6}>
//                 <div className='form-group mb-3'>
//                   <label className='form-label small fw-bold text-muted'>
//                     {t('نوع الدفع')} <span className='text-danger'>*</span>
//                   </label>
//                   <Form.Select
//                     disabled
//                     className='form-select'
//                     name='paymentType'
//                     onChange={handleChange}
//                     value={values.paymentType}
//                   >
//                     <option value=''>{t('اختر...')}</option>
//                     {PaymentTypeList?.map((item, idx) => (
//                       <option key={idx} value={item.id}>
//                         {i18n.language === 'en' ? item.name : item.name2}
//                       </option>
//                     ))}
//                   </Form.Select>
//                   {renderError('paymentType')}
//                 </div>
//               </Col>

//               {/* المورد */}
//               <Col lg={3} md={6}>
//                 <div className='form-group mb-3'>
//                   <label className='form-label small fw-bold text-muted'>
//                     {t('المورد')} <span className='text-danger'>*</span>
//                   </label>
//                   <TreeSelect
//                     disabled
//                     showSearch
//                     className='w-100'
//                     treeLine
//                     placeholder={t('اختر المورد...')}
//                     allowClear
//                     treeDefaultExpandAll={false}
//                     value={values.peopleId}
//                     onChange={option => setFieldValue('peopleId', option === null ? null : option)}
//                     treeData={treeSuppliersData}
//                     treeNodeFilterProp='title'
//                   />
//                   {renderError('peopleId')}
//                 </div>
//               </Col>

//               {/* الوحدة التشغيلية */}
//               <Col lg={3} md={6}>
//                 <div className='form-group mb-3'>
//                   <label className='form-label small fw-bold text-muted'>
//                     {t('الوحدة التشغيلية')} <span className='text-danger'>*</span>
//                   </label>
//                   <Select
//                     classNamePrefix='react-select'
//                     isDisabled
//                     isLoading={loadingOperatingUnits}
//                     isSearchable={true}
//                     isClearable
//                     options={OperatingUnitOptions}
//                     value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId)}
//                     onChange={(option: any) => setFieldValue('organizationId', option?.value || '')}
//                     placeholder={t('اختر...')}
//                     menuPortalTarget={document.body}
//                     styles={{
//                       menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                     }}
//                   />
//                   {renderError('organizationId')}
//                 </div>
//               </Col>

//               {/* التاريخ */}
//               <Col lg={3} md={6}>
//                 <div className='form-group mb-3'>
//                   <label className='form-label small fw-bold text-muted'>
//                     {t('التاريخ')} <span className='text-danger'>*</span>
//                   </label>
//                   <Form.Control type='date' name='paymentDate' onChange={handleChange} value={values.paymentDate} />
//                   {renderError('paymentDate')}
//                 </div>
//               </Col>

//               {/* الحقول المشروطة */}
//               {showPaymentFields && (
//                 <>
//                   {/* طريقة الدفع */}
//                   <Col lg={3} md={6}>
//                     <div className='form-group mb-3'>
//                       <label className='form-label small fw-bold text-muted'>{t('طريقة الدفع')}</label>
//                       <Form.Select name='paymentMethodId' onChange={handleChange} value={values.paymentMethodId}>
//                         <option value=''>{t('اختر...')}</option>
//                         {PaymentMethodList?.map((item: any, idx: number) => (
//                           <option key={++idx} value={item.id}>
//                             {i18n.language === 'en' ? item.name : item.name2}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       {renderError('paymentMethodId')}
//                     </div>
//                   </Col>

//                   {/* البنك / الصندوق */}
//                   <Col lg={3} md={6}>
//                     <div className='form-group mb-3'>
//                       <label className='form-label small fw-bold text-muted'>{t('البنك / الصندوق')}</label>
//                       <Select
//                         classNamePrefix='react-select'
//                         isSearchable={true}
//                         isClearable
//                         options={groupedOptions}
//                         value={groupedOptions?.find((f: any) => f?.value === values.apBankAccountId)}
//                         onChange={(option: any) => setFieldValue('apBankAccountId', option?.value || null)}
//                         placeholder={t('اختر...')}
//                         menuPortalTarget={document.body}
//                         styles={{
//                           menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
//                         }}
//                       />
//                       {renderError('apBankAccountId')}
//                     </div>
//                   </Col>

//                   {/* العملة */}
//                   <Col lg={3} md={6}>
//                     <div className='form-group mb-3'>
//                       <label className='form-label small fw-bold text-muted'>{t('العملة')}</label>
//                       <Form.Select name='currencyCode' onChange={handleChange} value={values.currencyCode}>
//                         <option value=''>{t('اختر...')}</option>
//                         {Currency?.map((item: any, idx: number) => (
//                           <option key={++idx} value={item.currencyCode}>
//                             {item.description}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       {renderError('currencyCode')}
//                     </div>
//                   </Col>

//                   {/* سعر الصرف */}
//                   <Col lg={3} md={6}>
//                     <div className='form-group mb-3'>
//                       <label className='form-label small fw-bold text-muted'>{t('سعر الصرف')}</label>
//                       <InputGroup>
//                         <Form.Control
//                           className='form-control text-center'
//                           type='text'
//                           readOnly
//                           value={loadingRate ? '' : errorRate ? 'فشل التحميل' : rate}
//                           placeholder={loadingRate ? t('جاري التحميل...') : ''}
//                         />

//                         {loadingRate && (
//                           <InputGroup.Text>
//                             <div className='spinner-border spinner-border-sm text-primary'></div>
//                           </InputGroup.Text>
//                         )}

//                         {errorRate && !loadingRate && (
//                           <InputGroup.Text style={{ padding: '0' }}>
//                             <button
//                               type='button'
//                               className='btn btn-outline-warning h-100 px-2'
//                               onClick={refetch}
//                               title={t('إعادة تحميل سعر الصرف')}
//                             >
//                               <i className='fas fa-redo'></i>
//                             </button>
//                           </InputGroup.Text>
//                         )}
//                       </InputGroup>

//                       {errorRate && !loadingRate && (
//                         <small className='text-warning mt-1 d-block text-center'>
//                           <i className='fas fa-exclamation-circle me-1'></i>
//                           {t('تعذر تحميل السعر')}
//                           <button type='button' className='btn btn-link btn-sm p-0 text-warning ms-1' onClick={refetch}>
//                             ({t('إعادة المحاولة')})
//                           </button>
//                         </small>
//                       )}
//                     </div>
//                   </Col>

//                   {/* الوصف */}
//                   <Col lg={12}>
//                     <div className='form-group mb-3'>
//                       <label className='form-label small fw-bold text-muted'>{t('الوصف')}</label>
//                       <Form.Control
//                         as='textarea'
//                         rows={1}
//                         name='description'
//                         value={values.description}
//                         onChange={handleChange}
//                         onBlur={() => setFieldTouched('description', true)}
//                         placeholder={t('اكتب وصفاً مختصراً للسداد...')}
//                       />
//                       {renderError('description')}
//                     </div>
//                   </Col>
//                 </>
//               )}

//               {/* مبلغ الدفعة المقدمة */}
//               {values.paymentType === paymentTypeEnum.PrePayment && (
//                 <Col lg={3} md={6}>
//                   <div className='form-group mb-3'>
//                     <label className='form-label small fw-bold text-muted'>
//                       {t('مبلغ الدفعة المقدمة')} <span className='text-danger'>*</span>
//                     </label>
//                     <Form.Control
//                       className='form-control text-center fs-5 fw-bold text-theme'
//                       type='text'
//                       name='amount'
//                       onChange={handleChange}
//                       value={values.amount}
//                       onInput={e => {
//                         const input = e.target as HTMLInputElement;
//                         input.value = input.value.replace(/[^0-9]/g, '');
//                       }}
//                     />
//                     {renderError('amount')}
//                   </div>
//                 </Col>
//               )}
//             </Row>
//           </CardBody>
//         </Card>

//         {/* تفاصيل الدفع */}
//         <PaymentDetailsCard
//           paymentType={values.paymentType}
//           Id={
//             [paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(values.paymentType)
//               ? values.creditMemoInvoiceId
//               : values.paymentType === paymentTypeEnum.ApplyPrePayment
//                 ? values.prePaymentId
//                 : null
//           }
//           scheduleCount={values.scheduleList?.length || 0}
//         />

//         {/* جدول السداد */}
//         {showScheduleList && (
//           <Card className='shadow-sm border-0 mb-4'>
//             <ApScheduleList formik={formik} />
//           </Card>
//         )}

//         {/* أزرار الأكشن */}
//         <Card className='mt-3 p-3 shadow'>
//           <div className='d-flex justify-content-center gap-3'>
//             <button
//               type='button'
//               onClick={() => navigate('/AP/ApPayments', { replace: true })}
//               className='btn btn-outline-secondary px-4'
//             >
//               <i className='fas fa-times me-2'></i> {t('إلغاء')}
//             </button>

//             <button type='submit' disabled={isSubmitting} className='btn btn-theme px-5 fw-bold shadow'>
//               {isSubmitting ? (
//                 <span className='spinner-border spinner-border-sm me-2'></span>
//               ) : (
//                 <i className='fas fa-credit-card me-2'></i>
//               )}
//               {t('دفع')}
//             </button>
//           </div>
//         </Card>
//       </Form>
//     </div>
//   );
// };

// export default Add;

/* eslint-disable prefer-const */
/* eslint-disable react-refresh/only-export-components */

import { useFormik } from 'formik';
import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { TreeSelect } from 'antd';
import { Card } from '@components/card/card';
import { CardBody, Form, InputGroup, Badge, Row, Col } from 'react-bootstrap';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import confirmAction from '@components/Shared/Alert/confirmAction';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import useGetBankAccountsList, { findOptionInGroups } from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
import useGetPaymentTypeList from '@hooks/Finance/ApPayments/useGetPaymentTypeList';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { useAppDispatch } from '@store/hooks';
import { useNavigate } from 'react-router-dom';
import { addApPayments, getApPaymentsList } from '@store/Finance/AP/ApPayments/ApPaymentsSlice';
import { AddApPaymentsSchema } from '../../../../ValidationForm/validationSchema';
import NeatixModal from '@components/Modal/NeatixModal';
import ChooseType from './ChooseType';
import ApScheduleList from '../ApScheduleList';
import { paymentTypeEnum } from '../paymentTypeEnum';
import PaymentDetailsCard from './PaymentDetailsCard';
import { useDailyRate } from '@hooks/Finance/DailyRates/useDailyRate';

const Add = () => {
  const [showModal, setShowModal] = useState(true);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);

  // البيانات المرجعية
  const { Currency, loading: loadingCurrency } = useLookupCurrency();
  const { OperatingUnitOptions, loading: loadingOperatingUnits } = useGetOperatingUnitWithPermission();
  const { treeSuppliersData, loading: loadingSuppliers } = useGetSuppliersList();
  const { PaymentMethodList, loading: loadingPaymentMethods } = useGetPaymentMethod();
  const { PaymentTypeList } = useGetPaymentTypeList();

  const todayDate = useMemo(() => new Date().toISOString().split('T')[0], []);

  const formik = useFormik({
    initialValues: {
      tranferFees: 0,
      tranferFees_VAT: 0,

      paymentType: paymentTypeEnum.Standard,
      paymentDate: todayDate,
      apBankAccountId: '',
      paymentMethodId: '',
      amount: 0,
      currencyCode: 'SAR',
      currencyConversionRate: 1,
      peopleId: null,
      organizationId: '',
      creditMemoInvoiceId: '',
      prePaymentId: '',
      description: '',
      scheduleList: [
        {
          apPaymentScheduleId: '',
          amount: 0
        }
      ]
    },

    enableReinitialize: true,
    validationSchema: AddApPaymentsSchema(t),

    onSubmit: async values => {
      const isConfirmation = await confirmAction(t('هل أنت متأكد من أنك تريد إضافة هذا السداد؟'));
      if (!isConfirmation) {
        formik.setSubmitting(false);
        return;
      }

      setIsSubmitting(true);
      const totalAmount = values.scheduleList?.reduce((sum: any, line: any) => sum + line.amount, 0) || 0;

      const payload = {
        apBankAccountId: values.apBankAccountId || null,
        paymentMethodId: values.paymentMethodId || null,
        paymentDate: values.paymentDate,
        // amount: [paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)
        //   ? values.amount
        //   : totalAmount,

        amount: [
          paymentTypeEnum.PrePayment,
          paymentTypeEnum.Refund,
          paymentTypeEnum.PrePaymentRefund // ← جديد
        ].includes(values.paymentType)
          ? values.amount
          : totalAmount,

        currencyCode: values.currencyCode,
        currencyConversionRate: rate,
        peopleId: values.peopleId,
        organizationId: values.organizationId,
        paymentType: values.paymentType,
        creditMemoInvoiceId: values.creditMemoInvoiceId || null,
        prePaymentId: values.prePaymentId || null,
        description: values.description?.trim() || '',

        tranferFees: Number(values.tranferFees) || 0,
        tranferFees_VAT: Number(values.tranferFees_VAT) || 0,

        scheduleList: [paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType)
          ? []
          : values.scheduleList.map((item: any) => ({
              apPaymentScheduleId: item.apPaymentScheduleId,
              amount: item.amount
            }))
      };

      try {
        const res = await dispatch(addApPayments(payload)).unwrap();
        if (res?.succeeded) {
          CustomAlert({ action: 'Add' });
          dispatch(getApPaymentsList());
          navigate('/AP/ApPayments', { replace: true });
        } else {
          CustomAlert({ action: 'Error', msg: res?.message });
        }
      } catch (error) {
        CustomAlert({ action: 'Error' });
      } finally {
        setIsSubmitting(false);
        formik.setSubmitting(false);
      }
    }
  });

  const { values, handleChange, errors, touched, setFieldValue, setFieldTouched } = formik;

  // ✅ البنوك/الصناديق حسب الوحدة التشغيلية
  const {
    groupedOptions,
    groupedCashOptions,
    groupedBankOptions,
    loading: loadingBankAccounts
  } = useGetBankAccountsList(values.organizationId);

  // ✅ تحميل جميع البيانات
  const loadingAllData = loadingCurrency || loadingOperatingUnits || loadingSuppliers || loadingPaymentMethods;

  // Daily Rate
  const {
    rate,
    loading: loadingRate,
    error: errorRate,
    refetch
  } = useDailyRate({
    currencyCode: values.currencyCode,
    date: values.paymentDate
  });

  // ✅ تحديد نوع طريقة الدفع (نقدي/تحويل) — fallback من الاسم
  const getPaymentMethodKind = (pm: any) => {
    if (!pm) return 'other';

    // لو عندك حقول صريحة عدّلها هنا
    const raw = pm?.methodType ?? pm?.paymentMethodType ?? pm?.type ?? pm?.code ?? pm?.key;

    if (typeof raw === 'string') {
      const s = raw.toLowerCase();
      if (s.includes('cash')) return 'cash';
      if (s.includes('transfer') || s.includes('bank')) return 'transfer';
    }

    const name = `${pm?.name ?? ''} ${pm?.name2 ?? ''}`.toLowerCase();
    if (name.includes('cash') || name.includes('نقد') || name.includes('كاش')) return 'cash';
    if (name.includes('transfer') || name.includes('تحويل') || name.includes('bank') || name.includes('بنك'))
      return 'transfer';

    return 'other';
  };

  const selectedPaymentMethod = useMemo(
    () => PaymentMethodList?.find((x: any) => x.id === values.paymentMethodId),
    [PaymentMethodList, values.paymentMethodId]
  );

  const paymentMethodKind = useMemo(() => getPaymentMethodKind(selectedPaymentMethod), [selectedPaymentMethod]);

  // ✅ الخيارات المعروضة في Select البنك/الصندوق
  const bankOptionsToShow = useMemo(() => {
    // const kind = getPaymentMethodKind(selectedPaymentMethod);
    const kind = paymentMethodKind;

    if (kind === 'cash') return groupedCashOptions;
    if (kind === 'transfer') return groupedBankOptions;
    return groupedOptions;
  }, [paymentMethodKind, groupedOptions, groupedCashOptions, groupedBankOptions]);

  // ✅ إذا تغيّرت طريقة الدفع وصارت القيمة المختارة غير موجودة في الخيارات الجديدة -> صفّرها
  useEffect(() => {
    if (!values.apBankAccountId) return;
    const exists = !!findOptionInGroups(bankOptionsToShow as any, values.apBankAccountId);
    if (!exists) setFieldValue('apBankAccountId', null);
  }, [bankOptionsToShow, values.apBankAccountId, setFieldValue]);

  // دالة مساعدة لعرض رسائل الخطأ
  const renderError = (fieldName: string) => {
    const tt = (touched as any)[fieldName];
    const e = (errors as any)[fieldName];
    return tt && e ? <div className='text-danger small mt-1'>{e as string}</div> : null;
  };

  // إخفاء بعض الحقول بناءً على نوع الدفع
  const showPaymentFields = ![
    paymentTypeEnum.ApplyDebitMemo,
    paymentTypeEnum.ApplyDebitMemo,
    paymentTypeEnum.ApplyPrePayment
  ].includes(values.paymentType);

  // const showScheduleList = ![paymentTypeEnum.PrePayment, paymentTypeEnum.Refund].includes(values.paymentType);

  // 2. إخفاء جدول السداد للنوع الجديد
  const showScheduleList = ![
    paymentTypeEnum.PrePayment,
    paymentTypeEnum.Refund,
    paymentTypeEnum.PrePaymentRefund // ← جديد
  ].includes(values.paymentType);

  if (loadingAllData) return <Loading loading={true} />;

  return (
    <div className='pb-5'>
      {/* الرأس (Header) */}
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            { name: 'Home', link: ':moduleHome' },
            { name: t('سندات الدفع'), link: '/AP/ApPayments' },
            { name: t('سند دفع جديد'), link: null }
          ]}
          PageName={
            <div className='d-flex align-items-center'>
              {t('سند دفع جديد')}
              {values.paymentType && (
                <Badge bg='primary' className='ms-3 fs-12px'>
                  {PaymentTypeList?.find(p => p.id === values.paymentType)?.[i18n.language === 'en' ? 'name' : 'name2']}
                </Badge>
              )}
            </div>
          }
        />
      </div>

      {/* نموذج اختيار النوع (Modal) */}
      <NeatixModal
        show={showModal}
        setShow={setShowModal}
        size='xl'
        bodyClassName='p-0'
        showHeader={false}
        keyboard={false}
        backdrop={true}
        centered
      >
        <Card>
          <ChooseType formik={formik} onClose={() => setShowModal(false)} />
        </Card>
      </NeatixModal>

      {/* النموذج الرئيسي */}
      <Form onSubmit={formik.handleSubmit}>
        <Card className='shadow-sm border-0 mb-4'>
          <CardBody>
            <Row>
              {/* نوع الدفع */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('نوع الدفع')} <span className='text-danger'>*</span>
                  </label>
                  <Form.Select
                    disabled
                    className='form-select'
                    name='paymentType'
                    onChange={handleChange}
                    value={values.paymentType}
                  >
                    <option value=''>{t('اختر...')}</option>
                    {PaymentTypeList?.map((item, idx) => (
                      <option key={idx} value={item.id}>
                        {i18n.language === 'en' ? item.name : item.name2}
                      </option>
                    ))}
                  </Form.Select>
                  {renderError('paymentType')}
                </div>
              </Col>

              {/* المورد */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('المورد')} <span className='text-danger'>*</span>
                  </label>
                  <TreeSelect
                    disabled
                    showSearch
                    className='w-100'
                    treeLine
                    placeholder={t('اختر المورد...')}
                    allowClear
                    treeDefaultExpandAll={false}
                    value={values.peopleId}
                    onChange={option => setFieldValue('peopleId', option === null ? null : option)}
                    treeData={treeSuppliersData}
                    treeNodeFilterProp='title'
                  />
                  {renderError('peopleId')}
                </div>
              </Col>

              {/* الوحدة التشغيلية */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('الوحدة التشغيلية')} <span className='text-danger'>*</span>
                  </label>
                  <Select
                    classNamePrefix='react-select'
                    isDisabled
                    isLoading={loadingOperatingUnits}
                    isSearchable={true}
                    isClearable
                    options={OperatingUnitOptions}
                    value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId)}
                    onChange={(option: any) => setFieldValue('organizationId', option?.value || '')}
                    placeholder={t('اختر...')}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                  {renderError('organizationId')}
                </div>
              </Col>

              {/* التاريخ */}
              <Col lg={3} md={6}>
                <div className='form-group mb-3'>
                  <label className='form-label small fw-bold text-muted'>
                    {t('التاريخ')} <span className='text-danger'>*</span>
                  </label>
                  <Form.Control type='date' name='paymentDate' onChange={handleChange} value={values.paymentDate} />
                  {renderError('paymentDate')}
                </div>
              </Col>

              {/* الحقول المشروطة */}
              {showPaymentFields && (
                <>
                  {/* طريقة الدفع */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('طريقة الدفع')}</label>
                      <Form.Select name='paymentMethodId' onChange={handleChange} value={values.paymentMethodId}>
                        <option value=''>{t('اختر...')}</option>
                        {PaymentMethodList?.map((item: any, idx: number) => (
                          <option key={idx} value={item.id}>
                            {i18n.language === 'en' ? item.name : item.name2}
                          </option>
                        ))}
                      </Form.Select>
                      {renderError('paymentMethodId')}
                    </div>
                  </Col>

                  {/* البنك / الصندوق */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('البنك / الصندوق')}</label>
                      <Select
                        classNamePrefix='react-select'
                        isSearchable={true}
                        isClearable
                        isLoading={loadingBankAccounts}
                        options={bankOptionsToShow}
                        value={findOptionInGroups(bankOptionsToShow as any, values.apBankAccountId)}
                        onChange={(option: any) => setFieldValue('apBankAccountId', option?.value || null)}
                        placeholder={t('اختر...')}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                      {renderError('apBankAccountId')}
                    </div>
                  </Col>

                  {/* العملة */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('العملة')}</label>
                      <Form.Select name='currencyCode' onChange={handleChange} value={values.currencyCode}>
                        <option value=''>{t('اختر...')}</option>
                        {Currency?.map((item: any, idx: number) => (
                          <option key={idx} value={item.currencyCode}>
                            {item.description}
                          </option>
                        ))}
                      </Form.Select>
                      {renderError('currencyCode')}
                    </div>
                  </Col>

                  {/* سعر الصرف */}
                  <Col lg={3} md={6}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('معدل تحويل العملة')}</label>
                      <InputGroup>
                        <Form.Control
                          className='form-control text-center'
                          type='text'
                          readOnly
                          value={loadingRate ? '' : errorRate ? 'فشل التحميل' : rate}
                          placeholder={loadingRate ? t('جاري التحميل...') : ''}
                        />

                        {loadingRate && (
                          <InputGroup.Text>
                            <div className='spinner-border spinner-border-sm text-primary'></div>
                          </InputGroup.Text>
                        )}

                        {errorRate && !loadingRate && (
                          <InputGroup.Text style={{ padding: '0' }}>
                            <button
                              type='button'
                              className='btn btn-outline-warning h-100 px-2'
                              onClick={refetch}
                              title={t('إعادة تحميل سعر الصرف')}
                            >
                              <i className='fas fa-redo'></i>
                            </button>
                          </InputGroup.Text>
                        )}
                      </InputGroup>

                      {errorRate && !loadingRate && (
                        <small className='text-warning mt-1 d-block text-center'>
                          <i className='fas fa-exclamation-circle me-1'></i>
                          {t('تعذر تحميل السعر')}
                          <button type='button' className='btn btn-link btn-sm p-0 text-warning ms-1' onClick={refetch}>
                            ({t('إعادة المحاولة')})
                          </button>
                        </small>
                      )}
                    </div>
                  </Col>

                  {/* رسوم التحويل وVAT عليها - تظهر فقط عند طريقة تحويل */}
                  {paymentMethodKind === 'transfer' && (
                    <>
                      <Col lg={3} md={6}>
                        <div className='form-group mb-3'>
                          <label className='form-label small fw-bold text-muted'>{t('رسوم التحويل')}</label>
                          <Form.Control
                            type='text'
                            name='tranferFees'
                            value={values.tranferFees}
                            onChange={handleChange}
                            // onInput={(e: any) => {
                            //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            // }}
                            onInput={e => {
                              const input = e.target as HTMLInputElement;
                              input.value = input.value
                                .replace(/[^0-9.]/g, '') // يسمح بالأرقام و .
                                .replace(/(\..*)\./g, '$1'); // يمنع أكثر من نقطة
                            }}
                            placeholder='0.0'
                            className='text-center'
                          />
                          {renderError('tranferFees')}
                        </div>
                      </Col>

                      <Col lg={3} md={6}>
                        <div className='form-group mb-3'>
                          <label className='form-label small fw-bold text-muted'>{t('ضريبة رسوم التحويل')}</label>
                          <Form.Control
                            type='text'
                            name='tranferFees_VAT'
                            value={values.tranferFees_VAT}
                            onChange={handleChange}
                            // onInput={(e: any) => {
                            //   e.target.value = e.target.value.replace(/[^0-9]/g, '');
                            // }}
                            onInput={e => {
                              const input = e.target as HTMLInputElement;
                              input.value = input.value
                                .replace(/[^0-9.]/g, '') // يسمح بالأرقام و .
                                .replace(/(\..*)\./g, '$1'); // يمنع أكثر من نقطة
                            }}
                            placeholder='0.0'
                            className='text-center'
                          />
                          {renderError('tranferFees_VAT')}
                        </div>
                      </Col>
                    </>
                  )}

                  {/* الوصف */}
                  <Col lg={12}>
                    <div className='form-group mb-3'>
                      <label className='form-label small fw-bold text-muted'>{t('الوصف')}</label>
                      <Form.Control
                        as='textarea'
                        rows={1}
                        name='description'
                        value={values.description}
                        onChange={handleChange}
                        onBlur={() => setFieldTouched('description', true)}
                        placeholder={t('اكتب وصفاً مختصراً للسداد...')}
                      />
                      {renderError('description')}
                    </div>
                  </Col>
                </>
              )}

              {/* مبلغ الدفعة المقدمة */}
              {/* {values.paymentType === paymentTypeEnum.PrePayment && (
                <Col lg={3} md={6}>
                  <div className='form-group mb-3'>
                    <label className='form-label small fw-bold text-muted'>
                      {t('مبلغ الدفعة المقدمة')} <span className='text-danger'>*</span>
                    </label>
                    <Form.Control
                      className='form-control text-center fs-5 fw-bold text-theme'
                      type='text'
                      name='amount'
                      onChange={handleChange}
                      value={values.amount}
                      onInput={e => {
                        const input = e.target as HTMLInputElement;
                        input.value = input.value.replace(/[^0-9]/g, '');
                      }}
                    />
                    {renderError('amount')}
                  </div>
                </Col>
              )} */}
              {[paymentTypeEnum.PrePayment, paymentTypeEnum.PrePaymentRefund].includes(values.paymentType) && (
                <Col lg={3} md={6}>
                  <div className='form-group mb-3'>
                    <label className='form-label small fw-bold text-muted'>
                      {values.paymentType === paymentTypeEnum.PrePaymentRefund
                        ? t('مبلغ الاسترداد')
                        : t('مبلغ الدفعة المقدمة')}{' '}
                      <span className='text-danger'>*</span>
                    </label>
                    <Form.Control
                      className='form-control text-center fs-5 fw-bold text-theme'
                      type='text'
                      name='amount'
                      onChange={handleChange}
                      value={values.amount}
                      onInput={e => {
                        const input = e.target as HTMLInputElement;
                        input.value = input.value.replace(/[^0-9]/g, '');
                      }}
                    />
                    {renderError('amount')}
                  </div>
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>

        {/* تفاصيل الدفع */}
        {/* <PaymentDetailsCard
          paymentType={values.paymentType}
          Id={
            [paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(values.paymentType)
              ? values.creditMemoInvoiceId
              : values.paymentType === paymentTypeEnum.ApplyPrePayment
                ? values.prePaymentId
                : null  
          }
          scheduleCount={values.scheduleList?.length || 0}
        /> */}
        <PaymentDetailsCard
          paymentType={values.paymentType}
          Id={
            [paymentTypeEnum.ApplyDebitMemo, paymentTypeEnum.Refund].includes(values.paymentType)
              ? values.creditMemoInvoiceId
              : [paymentTypeEnum.ApplyPrePayment, paymentTypeEnum.PrePaymentRefund].includes(values.paymentType) // ← تعديل
                ? values.prePaymentId
                : null
          }
          scheduleCount={values.scheduleList?.length || 0}
        />

        {/* جدول السداد */}
        {showScheduleList && (
          <Card className='shadow-sm border-0 mb-4'>
            <ApScheduleList formik={formik} />
          </Card>
        )}

        {/* أزرار الأكشن */}
        <Card className='mt-3 p-3 shadow'>
          <div className='d-flex justify-content-center gap-3'>
            <button
              type='button'
              onClick={() => navigate('/AP/ApPayments', { replace: true })}
              className='btn btn-outline-secondary px-4'
            >
              <i className='fas fa-times me-2'></i> {t('إلغاء')}
            </button>

            <button type='submit' disabled={isSubmitting} className='btn btn-theme px-5 fw-bold shadow'>
              {isSubmitting ? (
                <span className='spinner-border spinner-border-sm me-2'></span>
              ) : (
                <i className='fas fa-credit-card me-2'></i>
              )}
              {t('دفع')}
            </button>
          </div>
        </Card>
      </Form>
    </div>
  );
};

export default Add;
